import { Controller } from 'stimulus';
import Rails from '@rails/ujs';

export default class extends Controller {
  static values = { url: String };

  track() {
    Rails.ajax({ url: this.urlValue, type: 'POST' });
  }
}
